window.addEventListener('load', function () {
  const wrappers = document.querySelectorAll('.handwrite');
  if (!wrappers.length) return;

  wrappers.forEach(wrapper => {
    const svg = wrapper.querySelector('svg');
    if (svg) svg.style.animationPlayState = 'running';

    const paths = Array.from(wrapper.querySelectorAll('path')).reverse();
    const stagger = parseFloat(wrapper.dataset.stagger || 0.08);
    let delay = 0;

    paths.forEach(p => {
      const len = p.getTotalLength();
      p.style.setProperty('--len', len);
      const dur = parseFloat(wrapper.dataset.speed || 1.8);
      p.style.setProperty('--dur', `${dur}s`);
      p.style.animationDelay = `${delay}s`;
      delay += stagger;
    });

    wrapper.style.setProperty('--delayFill', `${delay + 0.2}s`);
  });
});